export default __webpack_public_path__ + "static/media/make3.db9771d0.png";